import React, { useEffect, useState } from "react";
import { Icon, ItemMenu } from 'asocomponents';
import "./menu.css";

const Menu = () => {
  const [isOpen, setIsOpen] = useState(localStorage.getItem("menuOpen"));
  const [isUserLetrado, setIsUserLetrado] = useState()
  const [isUserMedico, setIsUserMedico] = useState()
  const [isUserTecnico, setIsUserTecnico] = useState()
  const [isUserJuicio, setIsUserJuicio] = useState()
  const [cuitUsuario, setCuitUsuario] = useState()

  useEffect(() => {
    const shouldOpenMenu = localStorage.getItem("menuOpen");
    if (shouldOpenMenu === "false") {
      setIsOpen(false);
    }
    setIsUserLetrado(sessionStorage.getItem('usuario') && JSON.parse(sessionStorage.getItem('usuario')).isUserLetrado)
    setIsUserMedico(sessionStorage.getItem('usuario') && JSON.parse(sessionStorage.getItem('usuario')).isUserMedico)
    setIsUserTecnico(sessionStorage.getItem('usuario') && JSON.parse(sessionStorage.getItem('usuario')).isUserTecnico)
    setIsUserJuicio(sessionStorage.getItem('usuario') && JSON.parse(sessionStorage.getItem('usuario')).isUserJuicio)
    setCuitUsuario(sessionStorage.getItem('usuario') && JSON.parse(sessionStorage.getItem('usuario')).usuario)
  }, [])

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    localStorage.setItem("menuOpen", (!isOpen).toString());
  };

  const handleMenuClick = () => {
    localStorage.setItem("menuOpen", "true");
    setIsOpen(true);
  };

  return (
    <div className={`floating-menu ${isOpen ? "" : "closed"}`}>
      <button className="toggle-button" onClick={toggleMenu}>
        {isOpen ? (
          <Icon type="arrow" alt="Ocultar menu" />
        ) : (
          <Icon type="list" alt="Mostrar menu" />
        )}
      </button>
      <div className="menu-content">
        <ul>
        {(cuitUsuario==="20262935079") &&
            <ItemMenu titulo="Actas Acuerdos" url="/actaAcuerdo" onClick={handleMenuClick} />}
          {(isUserLetrado) &&
            <ItemMenu titulo="Comprobantes" url="/comprobantes" onClick={handleMenuClick} />          }
          {(isUserLetrado || isUserMedico || isUserTecnico) &&
            <ItemMenu titulo="Facturas Estudio" url="/facturas" onClick={handleMenuClick} />
          }
          {(isUserLetrado) &&
            <ItemMenu titulo="Pagos sin Factura" url="/pagossinfactura" onClick={handleMenuClick} />
          }
          {(isUserJuicio) &&
            <ItemMenu titulo="Bandeja de Juicios" url="/juicios" onClick={handleMenuClick} />
          }
        </ul>
      </div>
    </div>
  );
};

export default Menu;
